export default __webpack_public_path__ + "static/media/trascina.f955880f.mp3";